const NAMESPACE = 'bstar_live_room_';

export default class Storage {
  static get(key) {
    const k = `${NAMESPACE}${key}`;
    return localStorage.getItem(k);
  }

  static set(key, value) {
    const k = `${NAMESPACE}${key}`;
    localStorage.setItem(k, value);
  }

  static remove(key) {
    const k = `${NAMESPACE}${key}`;
    localStorage.removeItem(k);
  }

  static clear() {
    localStorage.clear();
  }
}
